import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import SharedHelmet from "../Helmet";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds,MobileUnderCalAds } from "../../Ads";
const TITLE = "حاسبة حجم الغاز الالكترونية - تعلم كيفية حساب حجم الغاز بسهولة";
const DESCRIPTION =
  "حاسبة حجم الغاز الدقيقة: احسب حجم الغاز (باللتر أو المتر المكعب) مع شرح خطوات الحساب خطوة بخطوة! أدخل الضغط، درجة الحرارة، وكمية المادة (مول) وفق قانون الغازات المثالية - أداة أساسية للكيمياء والفيزياء والهندسة الكيميائية.";
const KEYWORDS = "حسب حجم الغاز, حاسبة حجم الغاز";
const OG_URL = "https://do-calculate.com/calculator/ar/gasvolume/";
function Calculator() {
  const [mass, setMass] = useState("");
  const [density, setDensity] = useState("");
  const [volume, setVolume] = useState("");
  const [explanation, setExplanation] = useState("");
  const [error, setError] = useState("");
  const handleCalculate = () => {
    if (!mass || !density) {
      setError("الرجاء إدخال الكتلة والكثافة بشكل صحيح");
      setVolume("");
      setExplanation("");
      return;
    }
    const massValue = parseFloat(mass);
    const densityValue = parseFloat(density);
    if (isNaN(massValue) || isNaN(densityValue)) {
      setError("الرجاء إدخال قيم صحيحة للكتلة والكثافة");
      setVolume("");
      setExplanation("");
      return;
    }
    const gasVolume = massValue / densityValue;
    setVolume(gasVolume.toFixed(2));
    setExplanation(
      `حجم الغاز (لتر) = الكتلة (جرام) / الكثافة = ${massValue} جرام / ${densityValue} جم/سم³ = ${gasVolume.toFixed(
        2
      )} لتر`
    );
    setError("");
  };
  return (
    <div className="rtl">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  حجم الغاز يمكن حسابه باستخدام قانون الغاز العام، الذي يعرف
                  بقانون بويل-ماريوت أو قانون الغاز المثالي. هذا القانون يصف
                  تصرف الغازات في ظروف معينة وهو عبارة عن معادلة رياضية. القانون
                  يُعبر عنه عادة بهذا الشكل: PV = nRT حيث:
                </p>
                <ul>
                  <li>
                    P هو الضغط (Pressure) بوحدة بسكال (Pa) أو غيرها من وحدات
                    الضغط.
                  </li>
                  <li>
                    V هو الحجم (Volume) بوحدة متر مكعب (m³) أو لتر (L)، ويجب
                    التأكد من توحيده مع وحدة الضغط.
                  </li>
                  <li>n هو عدد المولات (Number of moles) للغاز.</li>
                  <li>
                    R هو الثابت الغازي (Gas Constant) بوحدة جول/مول·كلفن
                    (J/(mol·K)).
                  </li>
                  <li>
                    T هو درجة الحرارة (Temperature) بوحدة كلفن (K)، ويجب التأكد
                    من توحيده مع وحدة الثابت الغازي.
                  </li>
                </ul>
                لحساب حجم الغاز، يمكننا ترتيب المعادلة كالتالي: <br />
                V = (nRT) / P <br />
                عندما تكون لديك القيم التالية: <br />
                <ul>
                  <li>n: عدد المولات للغاز.</li>
                  <li>R: الثابت الغازي (يعتمد على وحدات القياس المستخدمة).</li>
                  <li>T: درجة الحرارة المطلوبة بوحدة كلفن (Kelvin).</li>
                  <li>P: الضغط بوحدة بسكال (Pa).</li>
                  <li>
                    قم بإدخال هذه القيم في المعادلة وستحصل على حجم الغاز بوحدته
                    المناسبة (متر مكعب أو لتر)، وتأكد من توحيد وحدات القياس بشكل
                    صحيح.
                  </li>
                </ul>
                <hr />
              </div>
            </div>
            <MobileUnderCalAds />
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE} </h2>
                </div>
                <hr />
                                <div dir="rtl">
                  <div>
                    <div className="form-group d-flex align-items-center">
                      <b>
                        <label className="form-label ms-2">الكتلة (جرام)</label>
                      </b>
                      <input
                        type="number"
                        placeholder="80"
                        value={mass}
                        onChange={(e) => setMass(e.target.value)}
                        className="form-control"
                        style={{ width: "90%" }}
                      />
                    </div>
                    <br />
                    <div className="form-group d-flex align-items-center">
                      <b>
                        <label className="form-label ms-2">
                          الكثافة (جم/سم³)
                        </label>
                      </b>
                      <input
                        type="number"
                        placeholder="8"
                        value={density}
                        onChange={(e) => setDensity(e.target.value)}
                        className="form-control"
                        style={{ width: "90%" }}
                      />
                    </div>
                    <br />
                    <button
                      className="btn btn-success"
                      style={{ fontSize: "20px" }}
                      onClick={handleCalculate}
                    >
                      احسب حجم الغاز
                    </button>
                  </div>
                  <br />
                  <div>
                    {error !== "" ? (
                      <p className="p-3 mb-2 bg-warning text-white">
                        خطأ: {error}
                      </p>
                    ) : (
                      <>
                        {volume !== "" && (
                          <>
                            <p className="p-3 mb-2 bg-success text-white">
                              حجم الغاز (لتر): {volume} لتر
                            </p>
                            {explanation !== "" && (
                              <p className="p-3 mb-2 bg-info text-black">
                                خطوات الحساب: <br />
                                {explanation}
                              </p>
                            )}
                          </>
                        )}
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      {" "}
      <br />
    </div>
  );
}
export default Calculator;
